"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutdoorSpace$ = exports.OutdoorSpace$outboundSchema = exports.OutdoorSpace$inboundSchema = void 0;
exports.outdoorSpaceToJSON = outdoorSpaceToJSON;
exports.outdoorSpaceFromJSON = outdoorSpaceFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const meta_js_1 = require("./meta.js");
/** @internal */
exports.OutdoorSpace$inboundSchema = z.object({
    garden_direction: z.nullable(z.string()),
    garden_primary_orientation: z.nullable(z.string()),
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    outdoor_space_area_square_metres: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "garden_direction": "gardenDirection",
        "garden_primary_orientation": "gardenPrimaryOrientation",
        "outdoor_space_area_square_metres": "outdoorSpaceAreaSquareMetres",
    });
});
/** @internal */
exports.OutdoorSpace$outboundSchema = z.object({
    gardenDirection: z.nullable(z.string()),
    gardenPrimaryOrientation: z.nullable(z.string()),
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    outdoorSpaceAreaSquareMetres: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        gardenDirection: "garden_direction",
        gardenPrimaryOrientation: "garden_primary_orientation",
        outdoorSpaceAreaSquareMetres: "outdoor_space_area_square_metres",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OutdoorSpace$;
(function (OutdoorSpace$) {
    /** @deprecated use `OutdoorSpace$inboundSchema` instead. */
    OutdoorSpace$.inboundSchema = exports.OutdoorSpace$inboundSchema;
    /** @deprecated use `OutdoorSpace$outboundSchema` instead. */
    OutdoorSpace$.outboundSchema = exports.OutdoorSpace$outboundSchema;
})(OutdoorSpace$ || (exports.OutdoorSpace$ = OutdoorSpace$ = {}));
function outdoorSpaceToJSON(outdoorSpace) {
    return JSON.stringify(exports.OutdoorSpace$outboundSchema.parse(outdoorSpace));
}
function outdoorSpaceFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OutdoorSpace$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OutdoorSpace' from JSON`);
}
//# sourceMappingURL=outdoorspace.js.map